import { UPDATE_RESOURCE_DEFINITIONS } from 'constants/actions';

const DEBUG_LOG = () => {};
// const DEBUG_LOG = (msg) => console.log(`[RemoteResources] ${ msg }`);

const initialState = {};

const remoteResources = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_RESOURCE_DEFINITIONS: {
      DEBUG_LOG(`Updating resources (${action.resourceType})`);
      const newState = {};

      // add new definitions to the new state
      action.resourceDefs.forEach((def) => {
        newState[def.identifier] = def;
        DEBUG_LOG(`- Received resource '${def.identifier}'`);
      });

      // add existing resources of different type to the new state
      Object.keys(state).forEach((identifier) => {
        const resource = state[identifier];
        if (resource.resource_type !== action.resourceType) {
          newState[identifier] = resource;
        }
      });

      return newState;
    }
    default:
      return state;
  }
};

export default remoteResources;
